import { TransformInt } from '../../../shared/decorators/transform-int.decorator';

/**
 * Reservation info pricing item DTO
 */
export class ReservationInfoPricingItemDto {
	pricingItemPresetUuid?: string;
	@TransformInt()
	pricingItemPresetId?: number;
	@TransformInt()
	units?: number;
}
